import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, SelectLabel, TooltipHelp } from '@weezevent/nacre';
import { capitalizeFirstLetter } from '../../../attendee/detail/components/utils';

export default function ActionOnRatesModal({ type, selectedId, title = null, subtitle = null, onSave, onClose, options, showModal, isSubmitting = false, tooltip = null }) {
    const { t } = useTranslation();
    const [ObjectIdSelected, setObjectiId] = React.useState(selectedId || null);
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        setObjectiId(selectedId);
        setSearch('');
    }, [selectedId]);

    const filtered = React.useMemo(() => {
        if (!search) return options;
        return options?.filter(o => o.text.toLowerCase().includes(search.toLowerCase()));
    }, [options, search]);

    if (!options) {
        return null;
    }

    return (
        <Modal
            open={showModal}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            submitButton={
                <Button
                    primary
                    disabled={isSubmitting || !ObjectIdSelected}
                    isLoading={isSubmitting}
                    onClick={() => onSave(ObjectIdSelected)}
                    label={t(`ticket.common.action.save`)}
                />
            }
            cancelButton={<Button onClick={onClose} label={t(`ticket.common.action.cancel`)} />}
        >
            <Form>
                <Form.Field>
                    <SelectLabel
                        value={ObjectIdSelected}
                        label={
                            <span>
                                {t(`ticket.rates.${type}`)}
                                {tooltip && <TooltipHelp title={tooltip} />}
                            </span>
                        }
                        onChange={value => setObjectiId(value)}
                        options={filtered}
                        placeholder={t(`ticket.rates.infos.placeholder${capitalizeFirstLetter(type)}`)}
                        clearable
                        onClear={() => setObjectiId(null)}
                        search
                        useNew
                        onInputChange={e => setSearch(e.target.value)}
                    />
                </Form.Field>
            </Form>
        </Modal>
    );
}

ActionOnRatesModal.propTypes = {
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    tooltip: PropTypes.node,
    isSubmitting: PropTypes.bool
};
